<template>
  <div class="sidebar" data-collapsed="true" data-color="azure" data-background-color="white">
    <div class="logo">
      <router-link :to="{'name': 'dashboard'}" class="text-center db">
        <img src="@/assets/template/images/logo.png" alt="Consyst" style="width: 50%">
      </router-link>
    </div>

    <div class="sidebar-wrapper">
      <ul class="nav">
        <router-link active-class="active" tag="li" class="nav-item" :to="{name: 'dashboard'}">
          <a class="nav-link">
            <i class="material-icons">dashboard</i>
            <p>Dashboard</p>
          </a>
        </router-link>
        <li class="nav-item" v-for="(iterator, k) in items" :key="iterator.id">
          <a class="nav-link" v-b-toggle="iterator.icon" 
            :aria-controls="iterator.icon"
            data-toggle="collapse"
            v-bind:v-b-toggle="iterator.icon">
            <i class="material-icons">{{ iterator.icon }}</i>
            <p>
              {{ iterator.name }}
              <b class="caret"></b>
            </p>
          </a>
          <b-collapse :id="iterator.icon" accordion="accordion-1" role="tabpanel">
            <ul class="nav">
              <router-link
                v-if="link.is_show_menu == 1"
                v-for="link in iterator.functionalities"
                active-class="active"
                tag="li"
                class="nav-item"
                :key="link.id"
                :to="{name: link.route +'.index'}"
              >
                <a class="nav-link" :title="link.name">
                  <span class="sidebar-mini">{{ link.name | abreviation }}</span>
                  <span class="sidebar-normal">{{ link.name | showCharacter }}</span>
                </a>
              </router-link>
            </ul>
          </b-collapse>
        </li>
      </ul>
    </div>
  </div>
</template>
<script scoped>
import jQuery from 'jquery';
import { Authenticate } from "@/middlewares/authenticate";

export default {
  computed: {
    items() {
      return this.$store.state.menu.itens;
    }
  },
  filters: {
    abreviation: function(_text) {
      if (_text.indexOf(" ") === -1) {
        return _text.substr(0, 2).toUpperCase();
      } else {
        var secondPartMini = _text
          .substr(_text.indexOf(" ") + 1, 1)
          .toUpperCase();
        return _text.charAt(0).toUpperCase() + secondPartMini;
      }

      return _text;
    },
    showCharacter : _text => {
      if(_text.length > 25)
        return _text.substr(0, 24)

      return _text
    }
  },
  mounted() {
    var self = this;
    self.$store.dispatch("menu/all");
    jQuery("#minimizeSidebar").trigger("click");
  }
};
</script>
<style type="scss" scoped>
.main-panel,
.sidebar,
.sidebar-wrapper {
  transition-property: top, bottom, width;
  transition-duration: 0.2s, 0.2s, 0.35s;
  transition-timing-function: linear, linear, ease;
  -webkit-overflow-scrolling: touch;
  z-index: 4;
}
.sidebar{
    z-index: 99999 !important;
}
.sidebar[data-background-color="white"] {
  background: #ffffff;
}
.sidebar .nav {
  padding-bottom: 60px;
}
.sidebar .nav .nav {
  padding-bottom: 15px;
}
.sidebar .nav-link {
  text-decoration: none !important;
}
.sidebar .nav li .dropdown-menu a,
.sidebar .nav li a {
  padding: 7px;
  padding-left: 10px;
  padding-right: 10px;
}
.sidebar .subactive {
  background-color: hsla(0, 0%, 78%, 0.2);
  color: #3c4858;
  box-shadow: none;
}
.sidebar
  .sidebar-wrapper
  .user
  .user-info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-mini,
.sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-mini {
  text-transform: uppercase;
  width: 30px;
  margin-right: 15px;
  text-align: center;
  letter-spacing: 1px;
  position: relative;
  float: left;
  display: inherit;
}
.sidebar
  .sidebar-wrapper
  .user
  .user-info
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-normal,
.sidebar
  .sidebar-wrapper
  > .nav
  [data-toggle="collapse"]
  ~ div
  > ul
  > li
  > a
  .sidebar-normal {
  margin: 0;
  position: relative;
  transform: translateX(0);
  opacity: 1;
  white-space: nowrap;
  display: block;
}
.sidebar[data-background-color="white"] .nav .nav-item .nav-link {
  display: block;
  overflow: hidden;
}
.sidebar .nav .nav .nav-link {
  height: 32px;
  font-size: 11px;
}
.sidebar .sidebar-wrapper a .sidebar-mini {
  padding-right: 8px;
  width: 25px;
}
.nav-link > .nav-link {
  
}
.sidebar .sidebar-wrapper a .sidebar-mini,
.sidebar .sidebar-wrapper a .sidebar-normal {
  float: left;
}

.sidebar .sidebar-wrapper a .sidebar-normal {
    max-width: 175px;
    max-height: 20px;
    overflow: hidden;
}
</style>